import { create } from 'zustand';

import type { SessionUser } from './usuario.entity';

type SesionState = {
  /** Access token en MEMORIA. Nunca se persiste (politica §7 maestro). */
  accessToken: string | null;
  user: SessionUser | null;
  /** Token efimero (5 min) para flujo MFA en /login/mfa. */
  mfaSessionToken: string | null;
  /**
   * Token efímero (~15 min) para flujo de enrolamiento MFA forzoso
   * en /login/mfa-setup. Solo presente cuando el login retornó
   * `mfa-enrollment-required` (ADR-016).
   */
  mfaEnrollmentToken: string | null;
  /** True cuando ya se intento hidratar via /auth/me al menos una vez. */
  isHydrated: boolean;
  /** True cuando hay accessToken Y user. */
  isAuthenticated: boolean;

  setSesion: (params: { accessToken: string; user: SessionUser }) => void;
  setAccessToken: (token: string) => void;
  setMfaChallenge: (token: string) => void;
  clearMfaChallenge: () => void;
  setMfaEnrollment: (token: string) => void;
  clearMfaEnrollment: () => void;
  setHydrated: (value: boolean) => void;
  clear: () => void;
};

export const useSesionStore = create<SesionState>((set) => ({
  accessToken: null,
  user: null,
  mfaSessionToken: null,
  mfaEnrollmentToken: null,
  isHydrated: false,
  isAuthenticated: false,

  setSesion: ({ accessToken, user }) =>
    set({
      accessToken,
      user,
      isAuthenticated: true,
      mfaSessionToken: null,
      mfaEnrollmentToken: null,
    }),

  setAccessToken: (token) =>
    set((s) => ({
      accessToken: token,
      isAuthenticated: Boolean(s.user),
    })),

  setMfaChallenge: (token) => set({ mfaSessionToken: token }),
  clearMfaChallenge: () => set({ mfaSessionToken: null }),

  setMfaEnrollment: (token) => set({ mfaEnrollmentToken: token }),
  clearMfaEnrollment: () => set({ mfaEnrollmentToken: null }),

  setHydrated: (value) => set({ isHydrated: value }),

  clear: () =>
    set({
      accessToken: null,
      user: null,
      mfaSessionToken: null,
      mfaEnrollmentToken: null,
      isAuthenticated: false,
    }),
}));
